import {cn} from '../../lib/utils';
import {Icon} from '../Icon/Icon';

import type {FC} from 'react';

export interface ModalTabCompletedBadgeProps {
  label: string;
  className?: string;
}

/**
 * Replaces a tab label when the step has been fully completed.
 * Renders a green success chip with the step name and a check-circle icon.
 * Use inside multi-step modal tab labels to signal completion.
 */
export const ModalTabCompletedBadge: FC<ModalTabCompletedBadgeProps> = ({label, className}) => (
  <span
    data-slot="modal-tab-completed-badge"
    className={cn(
      'inline-flex h-10 items-center gap-2 rounded-md border border-border-success bg-background-success px-2 text-sm font-semibold text-text-success',
      className
    )}
  >
    <Icon name="check-circle" width={20} height={20} />
    {label}
  </span>
);
